"use client";

import React from "react";
import { ChevronUp, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function VisionaryLeadership() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="30021" id="precision-meets-imagination" className="relative h-screen min-h-[600px] w-full overflow-hidden bg-background text-foreground dark">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591244/img/industrial_hero_background.png)] bg-cover bg-center bg-fixed bg-no-repeat opacity-40" />
        {}
        <div className="absolute inset-0 bg-background/70 backdrop-blur-[2px]" />
      </div>

      {}
      <div className="absolute top-1/2 left-0 z-20 hidden -translate-y-1/2 flex-col lg:flex">
        <Button variant="default" size="icon" className="h-16 w-12 rounded-none border-b border-border/20 bg-secondary text-secondary-foreground hover:bg-accent hover:text-accent-foreground" aria-label="Previous section">
          <ChevronUp className="h-6 w-6" />
        </Button>
        <Button variant="default" size="icon" className="h-16 w-12 rounded-none bg-secondary text-secondary-foreground hover:bg-accent hover:text-accent-foreground" aria-label="Next section">
          <ChevronDown className="h-6 w-6" />
        </Button>
      </div>

      {}
      <div className="relative z-10 mx-auto flex h-full max-w-7xl flex-col justify-center px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={cn("flex max-w-3xl flex-col items-start text-left transition-all duration-1000 ease-out", isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0")}>
          <h1 className="font-sans text-6xl font-extrabold leading-[1.05] tracking-tighter text-white sm:text-7xl md:text-8xl">
            Quinn <br /> Studio
          </h1>

          <p className="mt-6 max-w-lg font-mono text-lg leading-relaxed tracking-wider !text-[hsl(208,7%,46%)] sm:text-xl">Precision Meets Imagination. Technical excellence in 3D printing, laser engraving, and digital design or modeling.</p>

          <div className="mt-8">
            <Button asChild size="lg" className="h-14 rounded-none bg-primary px-10 text-base font-bold uppercase tracking-widest text-primary-foreground shadow-2xl transition-all duration-300 hover:bg-accent hover:text-accent-foreground hover:scale-105 active:scale-95 border-2 border-transparent">
              <Link to="#initiate-your-project">Start Your Project</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}